<template>
    <div>
        <div class="container">
            <div class="d-flex flex-wrap justify-content-center gap-40">
                <template v-for="(item, index) in items">
                    <flexible-packaging-option
                        :key="item.title"
                        :active="store.data.unwind === item.title"
                        :icon="$getImg(item.imgSrc)"
                        :title="$trans(`storefront::flexible_packaging.${item.title}`)"
                        @click.native="handleClick(item.title)"
                    ></flexible-packaging-option>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import FlexiblePackagingOption from "../inc/FlexiblePackagingOption";

export default {
    components: {FlexiblePackagingOption},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    data() {
        return {
            items: [
                {
                    imgSrc: 'flexible-packaging/unwind/left-first@2x.png',
                    title: 'left_first',
                },
                {
                    imgSrc: 'flexible-packaging/unwind/right-first@2x.png',
                    title: 'right_first',
                },
                {
                    imgSrc: 'flexible-packaging/unwind/bottom-first@2x.png',
                    title: 'bottom_first',
                },
                {
                    imgSrc: 'flexible-packaging/unwind/top-first@2x.png',
                    title: 'top_first',
                },
            ]
        };
    },
    methods: {
        handleClick(value) {
            this.store.data.unwind = value;
            this.store.nextStep();
        }
    }
}
</script>
